import { htmlSafe } from "@ember/template";
import { registerRawHelper } from "discourse-common/lib/helpers";
import { renderIcon } from "discourse-common/lib/icon-library";
export default function icon(id) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return htmlSafe(renderIcon("string", id, options));
}
registerRawHelper("d-icon", icon);